import { Button, Flex, Link } from "@aircall/tractor";
import { Trans, useTranslation } from "react-i18next";

import { useHasReadLinePermission } from "@/hooks/useHasReadLinePermission/useHasReadLinePermission";
import { useUpdateLineSettings } from "@/hooks/useUpdateLineSettings/useUpdateLineSettings";
import { TranscriptionIllustrationLayout } from "../TranscriptionIllustrationLayout";
import { TranscriptionMessageTitle } from "../TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../TranscriptionSubTitle";

import TranscriptionOff from "@/assets/transcription_off.svg?react";
import { DASHBOARD_URL } from "@/constants/environment.constants";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";

export function TranscriptionNotEnabledMessage() {
  const { t } = useTranslation();
  const { line } = useGetLine();
  const hasReadLinePermission = useHasReadLinePermission();

  const handleOnClick = useUpdateLineSettings();

  const lineName = line?.name ?? "";
  return (
    <TranscriptionIllustrationLayout data-test="transcription-not-enabled-message">
      <TranscriptionOff />
      <TranscriptionMessageTitle data-test="transcription-off-title">
        {t("no_transcript.off_title")}
      </TranscriptionMessageTitle>
      {hasReadLinePermission && (
        <Flex flexDirection="column" alignItems="center" gap="s">
          <TranscriptionSubTitle data-test="transcription-off-description">
            <Trans i18nKey="no_transcript.off_description">
              Go to the settings of
              <Link href={`${DASHBOARD_URL}numbers/${line?.ID}`} target="blank">
                <>{{ lineName }}</>
              </Link>
              to activate transcription. Does this accurately describe the
              problem? If not, submit feedback.
            </Trans>
          </TranscriptionSubTitle>
          <Button onClick={handleOnClick}>{t("turn_on")}</Button>
        </Flex>
      )}
    </TranscriptionIllustrationLayout>
  );
}
